export default __webpack_public_path__ + "static/Residence-Club-2bbd23155d6745e6ccfd177261423f25.jpg";